import React from 'react';
import { Check } from 'lucide-react';
import { useLocale } from '../../contexts/LocaleContext';

const ITEM_KEYS = [
  'landing_also_included_item_1',
  'landing_also_included_item_2',
  'landing_also_included_item_3',
  'landing_also_included_item_4',
  'landing_also_included_item_5',
  'landing_also_included_item_6',
] as const;

export const AlsoIncluded: React.FC = () => {
  const { t } = useLocale();

  return (
    <div
      id="also-included"
      style={{
        marginTop: '72px',
        paddingTop: '56px',
        borderTop: '1px solid #e7e7e8',
      }}
    >
      <div style={{ textAlign: 'center', maxWidth: '640px', margin: '0 auto 40px' }}>
        <p
          style={{
            fontFamily: "'DM Mono', monospace",
            fontSize: '16px',
            lineHeight: '20px',
            fontWeight: 500,
            letterSpacing: '3.2px',
            textTransform: 'uppercase',
            color: 'var(--scribane-green)',
            margin: '0 0 18px',
          }}
        >
          {t('landing_also_included_aux')}
        </p>
        <h3
          style={{
            fontFamily: "'Inter', system-ui, sans-serif",
            fontWeight: 400,
            fontSize: 'clamp(22px, 3vw, 32px)',
            lineHeight: 1.2,
            letterSpacing: '-0.02em',
            margin: 0,
            color: 'rgb(39,39,41)',
          }}
        >
          <strong style={{ fontWeight: 800 }}>{t('landing_also_included_title_bold')}</strong>
          {' '}
          {t('landing_also_included_title_rest')}
        </h3>
      </div>

      <ul
        style={{
          listStyle: 'none',
          margin: 0,
          padding: 0,
          display: 'grid',
          gridTemplateColumns: 'repeat(auto-fit, minmax(260px, 1fr))',
          gap: '14px 28px',
          maxWidth: '920px',
          marginInline: 'auto',
        }}
      >
        {ITEM_KEYS.map((key) => (
          <li
            key={key}
            style={{
              display: 'flex',
              alignItems: 'flex-start',
              gap: '12px',
              fontFamily: "'Inter', system-ui, sans-serif",
              fontSize: '14px',
              lineHeight: '22px',
              color: '#686869',
            }}
          >
            <span
              style={{
                flexShrink: 0,
                width: '22px',
                height: '22px',
                borderRadius: '999px',
                background: '#effaf2',
                color: 'var(--scribane-green)',
                display: 'inline-flex',
                alignItems: 'center',
                justifyContent: 'center',
                marginTop: '1px',
              }}
              aria-hidden="true"
            >
              <Check size={14} strokeWidth={2.5} />
            </span>
            <span>{t(key)}</span>
          </li>
        ))}
      </ul>
    </div>
  );
};
